/* eslint-disable react/prefer-stateless-function */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>
import React, { Component } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';

import {
  getProfile,
  getSuccess,
  getPaypal,
  getConfirmPaypalEmail,
  getValidatePaypalResult,
} from '../../MyProfile/store/selectors';
import * as profileActions from '../../MyProfile/store/actions';
import {
  Description,
  BankTransfer,
  PayPal,
} from '../../../../../../../components';
import styles from './styles';
import secure from '../../../../../../../images/secure-icon.png';
import {
  BANK_TRANSFER,
  PAYPAL,
} from '../../../../../../../config/constants';
import { CRAFTY_CLICKS_API_KEY } from '../../../../../../../config/apiKeys';
import ProfileMenuResriction from '../../ProfileMenuResriction';


class Payment extends Component {
  state = {};

  onSubmitBankTransfer = () => {
    const id = localStorage.getItem('loggedID');
    const token = localStorage.getItem('token');
    this.props.verifyBankAccount(
      {
        key: CRAFTY_CLICKS_API_KEY,
        sortCode: this.props.profile.bank.SortCode,
        accountNumber: this.props.profile.bank.AccountNumber,
      },
      {
        profile: this.props.profile,
        id,
        token,
        pageInfo: {
          page: 'payment',
          isBank: true,
          isPaypal: false,
        },
      },
    );
  }

  onSubmitPayPal = () => {
    const aboutPage = {
      page: 'payment',
      isBank: false,
      isPaypal: true,
    };
    localStorage.setItem('profile', JSON.stringify(this.props.profile));
    localStorage.setItem('aboutPage', JSON.stringify(aboutPage));
    this.props.validatePayPalEmail({
      PaypalEmail: this.props.paypal.PaypalEmail,
      ConfirmPaypalEmail: this.props.ConfirmPaypalEmail,
    });
  }

  componentWillUnmount() {
    this.props.resetErrorsAndSuccess();
  }

  render() {
    const { classes, success, profile } = this.props;
    const isTradeCustomer = JSON.parse(localStorage.getItem('TradeCustomer'));
    const noteText = ` Your method of payment can't be altered
     once a shipment has been received by SellitBack.com`;
    const secureText = 'We keep your information secure';

    return isTradeCustomer
      ? <ProfileMenuResriction />
      : (
        <div className={classes.container}>
          <form className={classes.paymentForm}>
            <MediaQuery maxWidth={549}>
              <Description text={'Payment'} />
            </MediaQuery>
            <div className={classes.paymentTypeContainer}>
              <BankTransfer
                type={BANK_TRANSFER}
                text={'BANK ACCOUNT'}
                paymentIndex={false}
                updateStatus={success}
                bank={profile.bank}
                onSubmit={() => this.onSubmitBankTransfer()}
              />
              <PayPal
                type={PAYPAL}
                paymentIndex={false}
                updateStatus={success}
                confirmStatus={this.props.validatePaypalResult}
                onSubmit={() => this.onSubmitPayPal()}
              />
            </div>
            <p className={classes.noteText}>
              <span className={classes.noteTextBold}>Note:</span>
              {noteText}
            </p>
            <div className={classes.secureTextContainer}>
              <img className={classes.secureImage} src={secure} alt={'secure'} />
              <span
                className={classNames(
                  classes.noteText,
                  classes.noteTextBold,
                  classes.marginLeft
                )}
              >
                {secureText}
              </span>
            </div>
          </form>
        </div>
      );
  }
}

Payment.propTypes = {
  classes: PropTypes.object,
  profile: PropTypes.object,
  success: PropTypes.object,
  paypal: PropTypes.object,
  ConfirmPaypalEmail: PropTypes.string,
  validatePaypalResult: PropTypes.object,
  validatePayPalEmail: PropTypes.func,
  resetErrorsAndSuccess: PropTypes.func,
  verifyBankAccount: PropTypes.func,
};

Payment.defaultProps = {
  classes: {},
  profile: {},
  success: {},
  paypal: {},
  ConfirmPaypalEmail: null,
  validatePaypalResult: {},
  validatePayPalEmail: () => { },
  resetErrorsAndSuccess: () => { },
  verifyBankAccount: () => { },
};

const mapStateToProps = (state) => {
  return {
    profile: getProfile(state),
    success: getSuccess(state),
    paypal: getPaypal(state),
    ConfirmPaypalEmail: getConfirmPaypalEmail(state),
    validatePaypalResult: getValidatePaypalResult(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    validatePayPalEmail: validatePayPal => dispatch(profileActions
      .validatePayPalEmail(validatePayPal)),
    resetErrorsAndSuccess: () => dispatch(profileActions.resetErrorsAndSuccess()),
    verifyBankAccount: (data, dataForNextRequest) => dispatch(profileActions
      .verifyBankAccount(data, dataForNextRequest)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Payment));
